import React, { useState, memo } from 'react';

import FormikFastInput from '../../formik/FormikFastInput';
import Button from '../../button';
import KoosJRModal from './KoosJRModal';

import { makeStyles } from '@material-ui/core';
import { connect } from 'formik';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  button: {
    height: 50,
    marginLeft: theme.spacing(1),
  },
  buttonWithError: {
    position: 'relative',
    bottom: 24,
  },
}));

const KoosJRActions = ({ isFollowUp, name, formik: { touched, errors } }) => {
  const classes = useStyles();
  const [activeModal, setActiveModal] = useState(false);
  const isErrorShowed = touched?.preOpData?.KOOSJR && errors?.preOpData?.KOOSJR;

  const toggleModal = () => {
    setActiveModal((prevValue) => !prevValue);
  };

  return (
    <div className={classes.root}>
      <FormikFastInput type='number' label='KOOS-JR' name={name} />
      <Button
        onClick={toggleModal}
        className={clsx(classes.button, isErrorShowed && classes.buttonWithError)}
      >
        Survey
      </Button>
      <KoosJRModal isFollowUp={isFollowUp} name={name} open={activeModal} onClose={toggleModal} />
    </div>
  );
};

export default connect(KoosJRActions);
